
import Vue from 'vue'
import SignInUp from '@/components/user/Sign-in-up.vue'
import DividerWithText from '@/components/DividerWithText.vue'
import EmailValidation from '@/service/EmailValidation'
import SocialLogin from '@/components/user/SocialLogin.vue'

export default Vue.extend({
  name: 'Sign-in',
  components: {
    SignInUp,
    DividerWithText,
    SocialLogin,
  },
  computed: {
    alertMessage: function (): string {
      const source = this.$route.query.source as string
      const status = this.$route.query.status as string

      if (!(source in this.alerts)) {
        return ''
      }

      if (!(status in this.alerts[source])) {
        return ''
      }

      return this.alerts[source][status]
    },
  },
  data: () => ({
    showPassword: false,
    email: '',
    password: '',
    rememberMe: false,
    emailRules: [
      (v: string) => !!v || 'E-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    requiredField: [(v: string) => !!v || "This field can't be empty."],
    signInBtnLoading: false,
    alerts: {
      userEmail: {
        registered: '',
        'waiting_for_parent':
          'Your account is active now. We have sent an e-mail to your parent asking for confirmation. You can sign in but we are waiting for your parent consent.',
        active: 'Your account is active now!',
      },
      parentEmail: {
        registered: '',
        'waiting_for_parent': '',
        active:
          "User's account is fully active now. Thank you for the confirmation.",
      },
      duringVerifyChild: {
        registered: "",
        'waiting_for_parent': 'You have already confirmed your email, waiting for your parent approval. If you would like to resend parent email, log in.',
        active:
            "Your account has already been activated.",
      },
      parentVerify: {
        registered: "User account has to be verified first.",
        'waiting_for_parent': "",
        'active': "User's account is already activated"
      },
      expiredSign: {
        registered: "This link has expired. Please log in again to generate a new link.",
        'waiting_for_parent': "Link have expired and it was resent, use new activation link."
      }
    } as Record<string, Record<string, string>>,
    showResendVerification: false,
    resendButtonLoading: false
  }),
  methods: {
    handleSubmit(ev: Event) {
      ev.preventDefault();
      // @ts-ignore
      if (!this.$refs.loginFormRef.validate()) return;

      this.signInBtnLoading = true
      this.$store
        .dispatch('authentication/signIn', {
          email: this.email,
          password: this.password,
          rememberMe: this.rememberMe,
          api: this.$api,
          returnTo: this.$route.query.returnTo,
        })
        .catch((err: any) => {
          const code = err.response?.data?.code;

          if (code === 'VERIFICATION_REQUIRED_EXPIRED') {
            this.$store.dispatch('alert/error', err.response.data.message, { root: true })
            this.showResendVerification = true;
            return;
          }
        })
        .finally(() => {
          this.signInBtnLoading = false
        })
    },
    handleResendVerification() {
      if(this.resendButtonLoading){
        return
      }

      this.resendButtonLoading = true

      this.$store.dispatch('authentication/resendVerification', {
        email: this.email,
        api: this.$api,
      }).finally(() => {
        this.resendButtonLoading = false
        this.showResendVerification = false
      })
    }
  },
})
